import { render } from "./BannedUserIndex.vue?vue&type=template&id=236c4538"
import script from "./BannedUserIndex.vue?vue&type=script&lang=js"
export * from "./BannedUserIndex.vue?vue&type=script&lang=js"

import "./BannedUserIndex.vue?vue&type=style&index=0&id=236c4538&lang=css"

import exportComponent from "/Users/ratul/Code/vue/jourly-admin-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__